/* talk·point — Blog-Liste: Live-Suche + „Mehr laden" (sections/tp-blog-list.liquid).
   Beides ist Aufsatz: ohne JS schickt das Formular auf /search?type=article und
   die Seitenlinks bleiben sichtbar. Suche über Shopifys Predictive Search, nur
   Artikel des eigenen Blogs. */
(() => {
  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  };

  const initSearch = (form) => {
    const input = form.querySelector('input[type="search"]');
    const drop = form.querySelector('.tp-bloglist__drop');
    const status = form.querySelector('[data-status]');
    const blogPath = form.dataset.blogUrl + '/';
    let timer;
    let seq = 0;

    const close = () => {
      drop.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    };

    const render = (q, hits) => {
      drop.replaceChildren();
      hits.slice(0, 5).forEach((a) => {
        const link = el('a', 'tp-bloglist__hit');
        link.href = a.url;
        if (a.image) {
          const img = el('img');
          img.src = a.image + (a.image.includes('?') ? '&' : '?') + 'width=160';
          img.alt = '';
          img.loading = 'lazy';
          link.append(img);
        }
        link.append(el('span', '', a.title));
        drop.append(link);
      });
      if (!hits.length) drop.append(el('p', 'tp-bloglist__drop-msg', `Kein Artikel zu „${q}“ gefunden.`));
      const all = el('a', 'tp-bloglist__drop-all', hits.length ? 'Alle Treffer anzeigen →' : 'Im ganzen Shop suchen →');
      all.href = `${form.action}?${hits.length ? 'type=article&' : ''}q=${encodeURIComponent(q)}`;
      drop.append(all);
      drop.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      status.textContent = hits.length ? `${Math.min(hits.length, 5)} Artikel gefunden` : 'Keine Artikel gefunden';
    };

    const run = async () => {
      const q = input.value.trim();
      if (q.length < 2) return close();
      const id = ++seq;
      const url = `${form.action}/suggest.json?q=${encodeURIComponent(q)}&resources[type]=article&resources[limit]=10`;
      try {
        const res = await fetch(url);
        const data = await res.json();
        if (id !== seq) return;
        const hits = (data.resources?.results?.articles || []).filter((a) => a.url.split('?')[0].startsWith(blogPath));
        render(q, hits);
      } catch {
        close();
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(run, 200);
    });
    input.addEventListener('focus', () => input.value.trim().length >= 2 && run());
    // Enter nicht abschicken: /search findet Ratgeber-Artikel schlecht, die Treffer stehen im Dropdown
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      clearTimeout(timer);
      run();
    });
    form.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        close();
        input.focus();
      }
    });
    form.addEventListener('focusout', (e) => {
      if (!form.contains(e.relatedTarget)) close();
    });
  };

  const initMore = (box) => {
    const btn = box.querySelector('button');
    const grid = box.closest('.tp-bloglist').querySelector('[data-grid]');
    box.hidden = false;
    btn.addEventListener('click', async () => {
      btn.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(btn.dataset.next);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const cards = doc.querySelectorAll('.tp-bloglist__grid > li');
        const first = cards[0]?.querySelector('a');
        grid.append(...cards);
        first && grid.querySelector(`a[href="${first.getAttribute('href')}"]`)?.focus({ preventScroll: true });
        const next = doc.querySelector('.tp-bloglist__loadmore button')?.dataset.next;
        if (next) btn.dataset.next = next;
        else {
          box.nextElementSibling?.remove(); // alles geladen: Seitenlinks wären jetzt irreführend
          box.remove();
        }
      } catch {
        // Seitenlinks wieder zeigen, wenn Nachladen scheitert
        box.remove();
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });
  };

  const init = () => {
    document.querySelectorAll('.tp-bloglist__search').forEach(initSearch);
    document.querySelectorAll('.tp-bloglist__loadmore').forEach(initMore);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
